import React from "react"
import { Link } from "gatsby"

import MapImg from "../../images/map.png"

const FunFactsArea = () => {
  return (
    <>
      <div className="funfacts-area ptb-80">
        <div className="container">
          <div className="section-title">
            <h2>Delivering Digital Excellence Through Innovation</h2>
            <div className="bar"></div>
            <p>
              We focus on building scalable web and mobile solutions that help
              businesses grow, optimize operations, and deliver exceptional
              user experiences.
            </p>
          </div>

          <div className="row">
            <div className="col-lg-3 col-md-3 col-6">
              <div className="funfact">
                <h3>120+</h3>
                <p>Projects Delivered</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-6">
              <div className="funfact">
                <h3>85+</h3>
                <p>Happy Clients</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-6">
              <div className="funfact">
                <h3>5+</h3>
                <p>Years Industry Experience</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-6">
              <div className="funfact">
                <h3>24/7</h3>
                <p>Technical Support</p>
              </div>
            </div>
          </div>

          <div className="contact-cta-box">
            <h3>Have a Project in Mind?</h3>
            <p>Let’s discuss how we can bring your ideas to life.</p>

            <Link to="/coming-soon" className="btn btn-primary">
              Get In Touch
            </Link>
          </div>

          <div className="map-bg">
            <img src={MapImg} alt="global presence map" />
          </div>
        </div>
      </div>
    </>
  )
}

export default FunFactsArea